// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Pj90","footer":"styles_footer__3TQXw"};